// 用户-服务
import user from './modules/user.js';
// 加密-服务
import encrypt from './modules/encrypt.js';
// 存储-服务
import storage from './modules/storage.js';
// ua-服务
import ua from './modules/ua.js';
// 工具-服务
import tool from './modules/tool.js';
// 路由-服务
import router from './modules/router.js';
// 通知-服务
import notification from './modules/notification.js';
// 日期-服务
import date from './modules/date.js';
// api-服务
import api from './modules/api.js';
// 网络-服务
import http from './modules/http.js';
// 文件-服务
import file from './modules/file.js';
// 界面-服务
import hud from './modules/hud.js';
// 图片-服务
import image from './modules/image.js';
// 地址
import region from './modules/region.js'
// 城市
import city from './modules/city.js'
import cityOnly from './modules/cityOnly.js'

export default {
  user,
  encrypt,
  storage,
  ua,
  tool,
  router,
  notification,
  date,
  api,
  http,
  file,
  image,
  region,
  city,
  cityOnly
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/index.js